import { useMutation } from 'react-query';

import { useToasts } from 'components/ToastProvider';
import { queryClient } from 'service/queryClient';
import {
  attachmentsKey,
  useAttachmentsQuery,
} from 'Attachment/query/attachment.query';
import { attachmentApi } from 'Attachment/service/attachment.api';
import { AttachmentList } from 'Attachment/component/AttachmentList/AttachmentList';

export const MyAttachmentList = () => {
  const { showError, showSuccess } = useToasts();
  const { data, isLoading } = useAttachmentsQuery();
  const { mutate: uploadAttachment } = useMutation(
    (files: File[]) => attachmentApi.uploadFiles(files),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(attachmentsKey);
        showSuccess('Upload attachment success');
      },
      onError: () => showError('Upload attachment failed'),
    }
  );

  return (
    <AttachmentList
      items={data?.result ?? []}
      loading={isLoading}
      allowRemoveAttachment={data?.canCurrentUserRemoveAttachments?? false}
      canUpload={true}
      onDropzoneSave={(files: File[]) => uploadAttachment(files)}
      onRemoveRequirementAttachmentSuccess={null}
    />
  );
};
